<template>
    <div>
        <section id="f-who-head1" class="section">



        </section>
        <section id="f-who-head2" class="section">


            <div class="container">


                <h1>O QUE É O FACÍLIMO</h1>
                <h3>O PROFISSIONAL QUE PRECISA ESTÁ AQUI</h3>
                <p>
                    O FACILIMO é a plataforma escolhida pelos portugueses no momento da contratação de um profissional para um serviço.
                </p>
                <p>
                    Com o FACILIMO os Utilizadores poderão encontrar a melhor opção para si, independentemente do tipo de serviço. Sejam arquitectos, pintores, electricistas, consultores imobiliários, advogados, tradutores ou qualquer outro tipo de profissional, poderão encontrar aqui quem pode realizar o seu projecto ou serviço. Ao receber uma proposta de um Profissional, poderá conhecer a sua avaliação por outros Utilizadores e toda a informação importante para uma boa tomada de decisão da sua parte.
                </p>
                <p>
                    Neste momento estamos a trabalhar em 6 áreas de negócio: Imobiliário, Casa, Certificação, Aulas, Climatização e Outros (todo o tipo de profissionais restantes).
                </p>
                <p>
                    O FACILIMO foi criado em 2017 e já está presente em Portugal e Brasil.
                </p>


                <h1 style="margin-top: 4rem">QUAL A NOSSA MISSÃO</h1>
                <p style="margin-top: 2rem">
                    A nossa missão é ajudar qualquer pessoa a realizar os seus projetos pessoais ao tornar o processo de contratação de qualquer Profissionais fácil e acessível.


                </p>

                <p>
                    Procuramos entregar ao Utilizador o máximo de informação possível validada para que a tomada de decisão pelo mesmo possa ser a mais correcta.

                </p>
  <p>
      O Utilizador, ao utilizar o Facilimo, recebe até 5 propostas de Profissionais em 48 horas para cada pedido que colocar, podendo prolongar o período de recepção de propostas ou aumentar o número de propostas.
                </p>
            </div>
        </section>

        <h1>LOCALIZAÇÃO</h1>
        <h3>ONDE ESTAMOS // PORTUGAL</h3>
        <div class="google-maps">
            <iframe
                    id="mapFrame"
                    width="600"
                    height="450"
                    frameborder="0" style="border:0"
                    src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBl_w8sFJDiONtBRB1ufaGaMdeO057RuDk
    &q=Centro,+Leiria+Portugal&language=pt_PT" allowfullscreen>
            </iframe>
        </div>

    </div>
</template>

<script>
    import {scrollTop} from "../plugins/scrollTopMixin";

    export default {
	    mixins: [scrollTop],

	    data() {
    return {};
  },
  methods: {},
  mounted() {},
  destroyed() {}
};
</script>
<style scoped>
.google-maps {
  margin-top: 4rem;
  position: relative;
  padding-bottom: 40%; // This is the aspect ratio
  height: 0;
  overflow: hidden;
}
.google-maps iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
}

h1 {
  font-weight: 500;
  font-size: 2.3rem;
  line-height: 1.15;
  color: #2d3256;
  margin: 1rem 0 0.5rem;
  padding: 0 2rem;
  text-align: center;
}

h3 {
  color: #969696;
  font-size: 0.8rem;
  text-align: center;
  margin-bottom: 1rem;
}

p {
  color: black;
  font-size: 1.2rem;
  line-height: 1.3;
  text-align: justify;
  padding: 1rem 0;
}

ul {
  padding: 0.5rem 2rem;
}

li {
  color: black;
  font-size: 1.2rem;
  line-height: 1.2;
}

i {
  color: #2d3256;
  margin-right: 1rem;
}

#f-who-head1 {
  background-image: url("/static/images/whoarewe/imagemtopo.jpg");
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 20rem;
}

#f-who-head2 {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/WhoAreWe.vue